import React from 'react';
import cns from 'classnames';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import { Link } from 'react-router-dom';
import Image from '../../../shared/components/Image';

const DimensionCard = (props) => {
    const {
        isReadOnly = false,
        className = '',
        dimension: { _id, thumbnailImageUrl, name = '', subtitle = '', isPrimary = false } = {}
    } = props;
    const link = isReadOnly ? null : `/dimension/${_id}`;
    const cardWithoutLink = (
        <div className={'row'}>
            <div className={cns('dimension-card', className)}>
                <div className={'dimension-card-content'}>
                    {!!thumbnailImageUrl && (
                        <div className={'col-12'}>
                            <Image
                                className={'dimension-image'}
                                src={thumbnailImageUrl}
                                dimension={{ h: 320, w: 480 }}
                            />
                        </div>
                    )}
                    <div className={'col-12'}>
                        <div className={`dimension-info ${isPrimary ? 'primary' : ''}`}>
                            <div
                                className={'dimension-name'}
                                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`<div>${name}</div>`) }}
                            />
                            <div className={'dimension-subtitle'}>{subtitle}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
    if (isReadOnly) {
        return cardWithoutLink;
    }
    return (
        <Link className={'card-link dimension-card-link'} to={link}>
            {cardWithoutLink}
        </Link>
    );
};

DimensionCard.propTypes = {
    dimension: PropTypes.object,
    isReadOnly: PropTypes.bool,
    className: PropTypes.string
};

export default DimensionCard;
